/**
 * Older reports only exist as the generated report file; their session markdown
 * fields were never filled. These build the same markdown from the file data.
 */

export function glanceMarkdownFromReport(sessionReport) {
  const atGlance = sessionReport?.['Session at a glance'];
  if (!atGlance) return '';
  return [
    atGlance.Summary && `## Summary\n\n${atGlance.Summary}`,
    atGlance.Keypoints && `## Keypoints\n\n${atGlance.Keypoints}`,
    atGlance.Speakers && `## Speakers\n\n${atGlance.Speakers}`,
  ].filter(Boolean).join('\n\n');
}

const joinNames = (value) => (Array.isArray(value) ? value.join(', ') : value);

const ARGUMENT_FIELDS = [
  ['Explanation', 'Explanation'],
  ['Evidence', 'Evidence'],
  ['External_evidence', 'External Evidence (Knowledge Base)'],
  ['Major discussion point', 'Major discussion point'],
  ['Agreed with', 'Agreed with', joinNames],
  ['Agreed on', 'Agreed on'],
  ['Disagreed with', 'Disagreed with', joinNames],
  ['Disagreed on', 'Disagreed on'],
];

export function speakersMarkdownFromReport(speakers) {
  if (!speakers) return '';
  return Object.entries(speakers).map(([speakerName, speakerArguments]) => {
    const argumentsMd = Object.entries(speakerArguments).map(([argumentName, argument]) => {
      const fields = ARGUMENT_FIELDS
        .filter(([key]) => argument[key])
        .map(([key, label, format]) => `**${label}:** ${format ? format(argument[key]) : argument[key]}`);
      return [`### ${argumentName}`, ...fields].join('\n\n');
    });
    return [`## ${speakerName}`, ...argumentsMd].join('\n\n');
  }).join('\n\n').trim();
}
